var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.5,
    height: 24.75,
    viewBox: "0 0 32.5 36.75",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svgGroup",
    strokeLinecap: "round",
    fillRule: "evenodd",
    fontSize: "9pt",
    stroke: "#fff",
    strokeWidth: "0.25mm",
    fill: "#fff",
    style: {
      stroke: "#fff",
      strokeWidth: "0.25mm",
      fill: "#fff"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 27.75 0 L 32.5 0 L 16.25 36.75 L 0 0 L 4.75 0 L 16.25 27.1 L 27.75 0 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVIcon);
export default __webpack_public_path__ + "static/media/v-icon.e7c94af914ffaa55306fe1a415b4ac50.svg";
export { ForwardRef as ReactComponent };